import { type TypeOptions as ToastTypes, toast } from "react-toastify";

export const showToast = (text = "", type: ToastTypes = "default"): void => {
  const toastOptions = {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const triggerToastFn = type === "default" ? toast : toast[type];
  triggerToastFn(text, toastOptions);
};
